import script from "./ContactTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactTable.vue?vue&type=script&setup=true&lang=js"

import "./ContactTable.vue?vue&type=style&index=0&id=72335f2c&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72335f2c"]])

export default __exports__